// extracted by mini-css-extract-plugin
export default {"modal_content":"AccountingGroupModal_modal_content__-HBMQ","modal_title":"AccountingGroupModal_modal_title__EmIIH"};